import { render, staticRenderFns } from "./DashboardUserScore.vue?vue&type=template&id=2dabac7a&"
import script from "./DashboardUserScore.vue?vue&type=script&lang=js&"
export * from "./DashboardUserScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports